import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { FooterComponent } from '../../../components/footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { MobileHeaderComponent } from "../../header/mobile-header/mobile-header.component";

@Component({
	selector: 'app-catalog-not-found',
	templateUrl: './catalog-not-found.component.html',
	styleUrls: ['./catalog-not-found.component.scss'],
	imports: [HeaderComponent, RouterLink, FooterComponent, TranslatePipe, MobileHeaderComponent]
})
export class CatalogNotFoundComponent implements OnInit {
	showSearchInNavbar = true;

	constructor(private metaService: Meta) { }

	async ngOnInit() {
		this.metaService.addTag({ name: 'robots', content: 'noindex' });
	}

}
